import React from 'react';
import { ButtonAction } from '../donate-form-utils';
import styles from '../DonateFormApp.scss';

interface DonateFormButtonProps {
    id: string;
    action: ButtonAction;
    onClick: () => void;
    disabled?: boolean;
}

const DonateFormButton = ({ id, action, onClick, disabled }: DonateFormButtonProps) => {
    const { style, text } = action;

    return (
        <button
            id={id}
            style={style}
            className={styles['donate-form-button']}
            onClick={onClick}
            disabled={disabled}>
            {text}
        </button>
    )
};

export default DonateFormButton;
